/** @ngInject */
export default function NotifiersController($stateParams, NotificationService, UtilService, notifiersService) {
  const vm = this;
  vm.isLoading = false;
  vm.notifiers = [];
  vm.notificationSystemId = $stateParams.notificationSystemId;
  vm.configTypes = ['REPLACE', 'ADD'];
  vm.targets = ['MERCHANT', 'CUSTOMER'];

  vm.init = init;
  vm.update = update;
  vm.remove = remove;

  init();

  function init() {
    getNotifiers();
  }

  function getNotifiers() {
    notifiersService.getNotifiers(vm.notificationSystemId).then(res => {
      vm.notifiers = res.data.merchantNotifiers;
    });
  }

  function update(notifier) {
    vm.isLoading = true;
    notifiersService
      .update(vm.notificationSystemId, notifier)
      .then(() => {
        NotificationService.success('Notifier updated');
      })
      .catch((res) => {
        NotificationService.error(res.data.errors[0].message)
      })
      .finally(() => {
        vm.isLoading = false;
      })
  }

  function remove(notifier) {
    vm.isLoading = true;
    notifiersService
      .remove(vm.notificationSystemId, notifier.id)
      .then(() => {
        NotificationService.success('Notifier deleted');
        UtilService.toggleElementFromArray(vm.notifiers, notifier)
      })
      .catch((res) => {
        NotificationService.error(res.data.errors[0].message)
      })
      .finally(() => {
        vm.isLoading = false;
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/webhooks/notifiers/notifiers.controller.js